import { gql } from "@apollo/client";export default gql`query concept($id: Int!) {
    concept: concept_by_pk(id: $id) {
        id
        title
    }
}
`;
